import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { setValidationForm } from '@common/helpers/utils';
import { OrganizationService } from '@shared/services/organization.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AppService } from 'projects/admin/src/app/core/services/app.service';

@Component({
  selector: 'lib-organization-dialog',
  templateUrl: './organization-dialog.component.html',
  styleUrls: ['./organization-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrganizationDialogComponent implements OnInit {

  form: FormGroup = this.formBuilder.group({
    id: null,
    name: ['', [Validators.required]],
  });
  isControlValid = setValidationForm(this.form);

  constructor(
    public ref: DynamicDialogRef,
    private formBuilder: FormBuilder,
    public appService: AppService,
    private organizationService: OrganizationService
  ) { }

  ngOnInit(): void {
  }

  onCancel() {
    this.ref.close();
  }
  async onSave() {
    this.form.markAllAsTouched();
    this.form.markAsDirty();
    if (this.form.valid) {
      const data = this.form.value;
      this.appService.startLoading();
      let resp;
      try {
        resp = await this.organizationService.add(data);
      } catch (error) {
        console.log("Error", error)
      }
      this.appService.stopLoading();
      this.ref.close({ id: resp });
    }
  }


}
